import { render } from "./CatalogSkeleton.vue?vue&type=template&id=84884eea&scoped=true"
import script from "./CatalogSkeleton.vue?vue&type=script&lang=js"
export * from "./CatalogSkeleton.vue?vue&type=script&lang=js"

import "./CatalogSkeleton.vue?vue&type=style&index=0&id=84884eea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84884eea"]])

export default __exports__